export var getTheme = function getTheme(theme) {
  return require("./".concat(theme, ".module.css"));
};
export var getRoundButtonTheme = function getRoundButtonTheme(theme) {
  return require("./".concat(theme, ".module.css"));
};